
<div class="row align-items-center m-t--10">
  <div class="col-sm-12 col-lg-12">
    <div class="d-flex align-items-center flexmob">
      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600"
           (click)="backToCharityOverView()">
        <i-tabler class="icon-20 m-r-4" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>

      <div class="m-l-10 d-flex align-items-center">

        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Independent Examiner's Report
          </h4>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Period Finalised & Ready to Submit-->
<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
              <h4>Period Finalised & Ready to Submit</h4>
              <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->



<form [formGroup]="form">

  <div class="m-t-0">
    <fieldset [disabled]="apFinalised" class="p-t-0 p-x-0">

      <mat-card-content class="p-0 bg-white" style="border-radius: 12px;">
        <div class="p-16 b-b-1 justify-content-center align-items-center" style=" border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important; border-radius: 12px;">

          <mat-card-content class="bg-white m-t-0 p-t-0 p-x-8">
            <!--<div class="p-b-10 d-flex justify-content-end">
    <button mat-flat-button   class="bg-none text-primary" style="height: 30px;" (click)="DefaultStatement('reportDescription')">
      <span> Default Statement </span>
    </button>
  </div>-->

            <div class="col-12 p-0 m-b-8">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="f-s-16 f-w-500 m-t-10 m-b-10 text-left" style="color: #31718f;">Opening Statement </h4>
                </div>
                <div class="col-md-6 text-right">
                  <button mat-flat-button [disabled]="apFinalised" class="bg-none text-primary defStatbtn" style="height: 30px;" (click)="CharithDetails?.jurisdiction_Charity === 'scotland' ? DefaultScotlandStatement('reportScotlandDescription') : DefaultStatement('reportDescription')">
                    <span> Default Statement </span>
                  </button>
                </div>
              </div>
            </div>

            <div class="NgxEditor__Wrapper"
                 style="min-height: 220px; border: 2px solid #eee !important;">

              <ngx-editor-menu [editor]="editor" [disabled]="apFinalised" [toolbar]="toolbar"></ngx-editor-menu>
              <!--<ngx-editor [editor]="editor"
                formControlName="reportDescription" (input)="MarkDirty()"
                [disabled]="false"
                placeholder="Type here...">

    </ngx-editor>-->
              <ngx-editor [editor]="editor"
                          [formControl]="CharithDetails?.jurisdiction_Charity === 'scotland'? form.get('reportScotlandDescription'): form.get('reportDescription')"
                          (input)="MarkDirty()"
                          [disabled]="apFinalised"
                          placeholder="Type here...">
              </ngx-editor>


            </div>


            <div class="col-12 p-0 m-b-8 m-t-20" *ngIf="CharithDetails?.jurisdiction_Charity !== 'scotland'">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <h4 class="f-s-16 f-w-500 m-t-10 m-b-10 text-left" style="color: #31718f;">Responsibilities and basis of report</h4>
                </div>
                <div class="col-md-6 text-right">
                  <button mat-flat-button [disabled]="apFinalised" class="bg-none text-primary defStatbtn" style="height: 30px;" (click)="DefaultStatement('responsibilitiesDescription')">
                    <span> Default Statement </span>
                  </button>
                </div>
              </div>
            </div>


            <mat-card-content class="m-t-10 p-x-0" *ngIf="CharithDetails?.jurisdiction_Charity !== 'scotland'">

              <div class="NgxEditor__Wrapper" style="min-height: 300px; border: 2px solid #eee !important;">
                <ngx-editor-menu [editor]="editor2" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor2" [formControl]="form.get('responsibilitiesDescription')"
                            (input)="MarkDirty()"
                            [disabled]="apFinalised" [placeholder]="'Type here...'"></ngx-editor>
              </div>
            </mat-card-content>

            <div class="col-12 p-0 m-b-8 m-t-20" *ngIf="CharithDetails?.jurisdiction_Charity === 'scotland'">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <h4 class="f-s-16 f-w-500 m-t-10 m-b-10 text-left" style="color: #31718f;">Respective responsibilities of trustees and examiner</h4>
                </div>
                <div class="col-md-6 text-right">
                  <button mat-flat-button [disabled]="apFinalised" class="bg-none text-primary defStatbtn" style="height: 30px;" (click)="DefaultScotlandStatement('responsibilitiesExaminerDescription')">
                    <span> Default Statement </span>
                  </button>
                </div>
              </div>
            </div>

            <mat-card-content class="m-t-10 p-x-0" *ngIf="CharithDetails?.jurisdiction_Charity === 'scotland'">
              <div class="NgxEditor__Wrapper" style="min-height: 300px; border: 2px solid #eee !important;">
                <ngx-editor-menu [editor]="editor4" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor4" [formControl]="form.get('responsibilitiesExaminerDescription')"
                            (input)="MarkDirty()"
                            [disabled]="apFinalised" [placeholder]="'Type here...'"></ngx-editor>
              </div>
            </mat-card-content>

            <div class="col-12 p-0 m-b-8 m-t-20" *ngIf="CharithDetails?.jurisdiction_Charity === 'scotland'">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <h4 class="f-s-16 f-w-500 m-t-10 m-b-10 text-left" style="color: #31718f;">Basis of independent examiner’s statement</h4>
                </div>
                <div class="col-md-6 text-right">
                  <button mat-flat-button [disabled]="apFinalised" class="bg-none text-primary defStatbtn" style="height: 30px;" (click)="DefaultScotlandStatement('basisIndependentDescription')">
                    <span> Default Statement </span>
                  </button>
                </div>
              </div>
            </div>

            <mat-card-content class="m-t-10 p-x-0" *ngIf="CharithDetails?.jurisdiction_Charity === 'scotland'">
              <div class="NgxEditor__Wrapper" style="min-height: 300px; border: 2px solid #eee !important;">
                <ngx-editor-menu [editor]="editor5" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor5" [formControl]="form.get('basisIndependentDescription')"
                            (input)="MarkDirty()"
                            [disabled]="apFinalised" [placeholder]="'Type here...'"></ngx-editor>
              </div>
            </mat-card-content>

            <div class="rows m-t-16" *ngIf="CharithDetails?.jurisdiction_Charity !== 'scotland'">
              <div class="col-sm-12 col-sm-12 brandbg20 border-radius10 p-10 p-x-16">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="label">
                    <mat-label class="f-s-14 f-w-600 p-b-8">Matter of Concern need to be disclosed</mat-label>
                  </div>
                  <div class="radio-selection">
                    <mat-radio-group aria-label="Select an option" [disabled]="apFinalised">
                      <mat-radio-button value="Yes" [checked]="ischecked" (change)="setVisibility($event)">Yes</mat-radio-button>
                      <mat-radio-button value="No" [checked]="!ischecked" (change)="setVisibility($event)">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-12 p-0 m-b-8 m-t-20">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <h4 class="f-s-16 f-w-500 m-t-10 m-b-10 text-left" style="color: #31718f;">Independent examiner's statement</h4>
                </div>
                <div class="col-md-6 text-right">
                  <button [disabled]="apFinalised" mat-flat-button class="bg-none text-primary defStatbtn" style="height: 30px;" (click)="CharithDetails?.jurisdiction_Charity === 'scotland' ? DefaultScotlandStatement('independentScotlandDescription') : DefaultStatement('independentDescription')">
                    <span> Default Statement </span>
                  </button>
                </div>
              </div>
            </div>

            <mat-card-content class="m-t-10 p-x-0">

              <div class="NgxEditor__Wrapper" style="min-height: 300px; border: 2px solid #eee !important;">
                <ngx-editor-menu [editor]="editor3" [disabled]="apFinalised" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor3" [formControl]="CharithDetails?.jurisdiction_Charity === 'scotland'? form.get('independentScotlandDescription'): form.get('independentDescription')"
                            (input)="MarkDirty()"
                            [disabled]="apFinalised" [placeholder]="'Type here...'"></ngx-editor>
              </div>
            </mat-card-content>

          </mat-card-content>
          <!-- <mat-error style="padding-left:inherit !important" *ngIf="form.get('reportDescription')?.value== '<p></p>' && form.get('reportDescription')?.touched">
            Please enter data [ngClass]="{ 'invalid-editor': isEditorEmpty() && form.get('reportDescription')?.touched }"
          </mat-error>-->


          <mat-card-content class="b-1 m-t-12 p-x-0">
            <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title" style="background: #e6f1f0;">
              <div class="d-flex align-items-center p-y-20">
                <div class="icon-holder">
                  <i-tabler class="icon-20 m-r-0 primary-color-dark" name="circle-check"></i-tabler>
                </div>
                <div class="">
                  <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Declaration</h4>
                  <p class="f-s-14 m-0">Approve and sign the report on behalf of the board of Independent Examiner's.</p>
                </div>
              </div>
            </mat-card-title>
            <div class="p-x-14 m-y-10 row">
              <div class="col-lg-4">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-20 m-r-10 primary-color-dark" name="user"></i-tabler>
                    <h5 class="f-w-600 f-s-14">
                      Examiner Name   <span class="text-danger"> *</span>
                    </h5>
                  </div>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select placeholder="Select Examiner" formControlName="examinerName" (selectionChange)="onTrusteeChange($event,'selected');MarkDirty()">
                    <mat-option (click)="modalAddAdvisor(template)" class="lightBtn">
                      <div class="d-flex thmeColor"><i-tabler class="icon-18 m-r-4" name="plus"></i-tabler>  <span class="hidemenutext">  Professional Adviser</span></div>

                    </mat-option>
                    <mat-option *ngFor="let advisor of filteredAdvisors1" [value]="advisor.professionalAdvisors_Name" matTooltipPosition="above"
                                matTooltipClass="expstat-tooltip"
                                [matTooltip]="advisor.professionalAdvisors_Name?.length > 48 ? advisor.professionalAdvisors_Name : ''">
                      {{ advisor.professionalAdvisors_Name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(form.get('examinerName')?.getRawValue() ==''||form.get('examinerName')?.getRawValue() ==null) && form.get('examinerName')?.touched">
                    Select a Examiner
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-24 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                    <h5 class="f-w-600 f-s-14">Approval Date <span class="text-danger"> *</span></h5>
                  </div>
                </mat-label>

                <mat-form-field appearance="outline" class="w-100">
                  <input matInput [disabled]="apFinalised" appTextMaskDate [matDatepicker]="picker" placeholder="dd/mm/yyyy" formControlName="approvalDate" (blur)="vldExamenirdateofapp($event);MarkDirty()" (dateChange)="vldExamenirdateofapp($event);MarkDirty()" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="form.get('approvalDate')?.hasError('required') && form.get('approvalDate')?.touched && !form.get('approvalDate')?.getRawValue()">
                    Approval Date is required
                  </mat-error>

                  <mat-error *ngIf="form.get('approvalDate')?.hasError('IsAfterToday')">
                    Approval Date should be on or between Accounting Period Start and Today's Date
                  </mat-error>

                  <mat-error *ngIf="form.get('approvalDate')?.hasError('InvalidDate')">
                    Approval Date is invalid
                  </mat-error>

                  <mat-error *ngIf="form.get('approvalDate')?.hasError('IsBeforeAP')">
                    Approval Date should be after Current Accounting Period Start date
                  </mat-error>

                  <mat-error *ngIf="form.get('approvalDate')?.hasError('IsBefore2015')">
                    Approval Date should be after 01-01-2015
                  </mat-error>
                </mat-form-field>

                <!--<mat-form-field appearance="outline" class="w-100">

                  <input matInput [matDatepicker]="picker1" placeholder="dd/mm/yyyy" class="date-left" appTextMaskDate formControlName="approvalDate" (dateChange)="vldtrusteedateofapp($event)"   />
                  <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>-->
              </div>
              <div class="col-lg-4">
                <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                  <div class="d-flex align-items-center">
                    <i-tabler class="icon-20 m-r-10 primary-color-dark" name="report"></i-tabler>
                    <h5 class="f-w-600 f-s-14">
                      Accounting Body
                    </h5>
                  </div>
                </mat-label>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select value="Other/None" formControlName="accountingBody" (selectionChange)="onaccounting($event);MarkDirty()">
                    <mat-option value="Other/None">Other/None</mat-option>
                    <mat-option value="CIMA">CIMA</mat-option>
                    <mat-option value="AAT">AAT</mat-option>
                    <mat-option value="AIA">AIA</mat-option>
                    <mat-option value="IFA">IFA</mat-option>
                    <mat-option value="ACCA">ACCA</mat-option>
                    <mat-option value="ICAEW">ICAEW</mat-option>
                    <mat-option value="ICAS">ICAS</mat-option>
                  </mat-select>
                </mat-form-field>

              </div>
              <!--show below section dynamic while choosing Trustee-->
              <div class="col-lg-12 d-none">
                <div class="rounded-2 b-1 p-14 m-y-6" style="border-radius: 6px; background: #e6f1f0;">
                  <p class="f-s-14 primary-color-dark">
                    The Trustees' annual report was approved on 17/09/2025 and signed on behalf of the board of trustees by: John Smith
                  </p>
                </div>
              </div>
            </div>
          </mat-card-content>

        </div>
      </mat-card-content>
    </fieldset>
  </div>

  <hr class="m-t-24" style="opacity:0.2" />
  <div class="row p-16">

    <div class="col-6 col-sm-6 col-md-4 m-b-16">
      <button mat-flat-button class="bg-warning text-end" (click)="BackToPrevious($event)">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
        </div>
      </button>
    </div>
    <div class="col-6 col-sm-6 col-md-8 m-b-16" align="right">
      <!--<button mat-flat-button   class="bgwhite border-light b-1 text-end m-r-10">
        <div class="d-flex text-black">
          <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
        </div>
      </button>-->
      <button mat-flat-button class="bg-success rounded-5" (click)="SaveExaminer()" [disabled]="!UserRoleAccess?.m1View">
        <div class="d-flex">
          <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark hidemenutext">Next</span>
        </div>
      </button>
    </div>
  </div>

</form>
<ng-template #template>
  <!--<mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="height">-->


  <div class="bg-light p-y-14 p-x-24">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <mat-card-title class="mat-mdc-card-title d-flex gap-10 align-items-center">
          <h4 class="f-s-26 f-w-700" style="white-space:nowrap;">{{ edithead ? 'Edit Professional Adviser' : 'Add Professional Adviser' }}</h4>
        </mat-card-title>
      </div>
      <div>

        <button class="d-flex justify-content-center  btn-close-dialog" (click)="closeAdvisor()">
          <i-tabler name="X" class="icon-20 m-r-2"></i-tabler>
        </button>
      </div>
    </div>
  </div>

  <form [formGroup]="ProfessionalAdvisorsCommonForm" class="p-x-24" validateOnTouch>
    <div class="m-t-20">
      <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading"> Professional Adviser <span class="text-danger"> *</span></mat-label>
      <mat-form-field appearance="outline" class="w-100 m-t-0">
        <!--<mat-select placeholder="Select Professional Adviser" formControlName="professionalAdvisors_Type">
        <mat-option *ngFor="let data of adviserTypes" value="{{data}}">{{data}}</mat-option>-->
        <!--<mat-option value="Banker">Banker</mat-option>
        <mat-option value="Solicitor">Solicitor</mat-option>
        <mat-option value="Independent Examiner">Independent Examiner</mat-option>
        <mat-option value="Auditor">Auditor</mat-option>-->
        <!--</mat-select>-->
        <mat-select formControlName="professionalAdvisors_Type">
          <mat-option value="Independent Examiner">Independent Examiner</mat-option>
        </mat-select>
        <mat-error *ngIf="ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Type')?.hasError('required') ">
          Select a Professional Adviser
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row m-t-0">
      <div class="col-sm-12">
        <mat-card class="cardWithShadow shadow-none" style="margin-bottom: 0px !important;">
          <mat-card-content class="p-0">
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Name<span class="text-danger"> *</span></mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="Name" appTrim formControlName="professionalAdvisors_Name" appInputRestriction="CompanyName" maxlength="50" />
                      <!--<input matInput placeholder="Name" appTrim formControlName="professionalAdvisors_Name" appInputRestriction="alphaNumeric" maxlength="50" />-->
                      <mat-error *ngIf="ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Name')?.hasError('required') ">
                        Name is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 1</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="Address Line 1" appTrim appInputRestriction="allowfewSpecialChars" formControlName="professionalAdvisors_Address_Line_1" maxlength="50" />
                      <mat-error *ngIf="ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Address_Line_1')?.hasError('required') ">
                        Address Line 1 is required
                      </mat-error>

                    </mat-form-field>

                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 2</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="Address Line 2" appTrim appInputRestriction="allowfewSpecialChars" formControlName="professionalAdvisors_Address_Line_2" maxlength="50" />
                      <mat-error *ngIf="ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Address_Line_2')?.hasError('required') ">
                        Address Line 2 is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Address Line 3</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="Address Line 3" appTrim appInputRestriction="allowfewSpecialChars" formControlName="professionalAdvisors_Address_Line_3" maxlength="50" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">City</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="City" maxlength="35" appInputRestriction="allowfewSpecialChars" formControlName="professionalAdvisors_City" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">County</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input matInput placeholder="County" formControlName="professionalAdvisors_County" maxlength="35" appInputRestriction="allowfewSpecialChars" (input)="checkadvisorformvalue()" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Country</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-select placeholder="Select Country" formControlName="professionalAdvisors_Country" (selectionChange)="validatepostcode(6)" (keydown)="onDropdownOpened($event)">
                        <mat-option value=''>Select Country</mat-option>
                        <mat-option *ngFor="let Country of AllCountriesList" [value]="Country.countryName">{{ Country.countryName }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-label class="f-s-14 f-w-600 d-block m-b-8 heading">Postcode</mat-label>
                  </div>
                  <div class="col-sm-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <input appAutoupperCase matInput placeholder="Postcode" formControlName="professionalAdvisors_Postcode" appTrim (blur)="validatepostcode($event)" appInputRestriction="postCode_UK" maxlength="9" />
                      <mat-error *ngIf="ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.hasError('required') ">
                        Postcode is required
                      </mat-error>
                      <mat-error *ngIf="ProfessionalAdvisorsCommonForm.get('professionalAdvisors_Postcode')?.hasError('invalid') ">
                        Enter valid Postcode
                      </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="d-none">
                      <input matInput placeholder="advisorsId" formControlName="advisorsId" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-12">
                <div class="row">
                  <div class="col-sm-12 d-flex align-items-center">
                    <mat-checkbox class="example-margin m-l--10" formControlName="isPrimary" (change)="onPrimaryExaminerChange($event)"></mat-checkbox>
                    <mat-label class="f-s-14 f-w-600 d-block heading m-l-4">
                      Mark as Primary
                    </mat-label>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </form>
  <!--<div class="d-flex container b-t-1 p-t-20 m-t-24 p-x-0 justify-content-between " *ngIf="this.editCharityBlock != true">

  </div>-->
  <div class="justify-content-end text-right d-flex p-x-0 bg-light p-y-14 p-x-24">

    <!--<button mat-flat-button class="bg-info m-r-10" (click)="AddAdvisor()" *ngIf="addAdvisorbtn" [disabled]="!UserRoleAccess?.m1Add">-->
    <button mat-flat-button class="bg-info m-r-10" (click)="AddAdvisor()" *ngIf="addAdvisorbtn" [disabled]="!UserRoleAccess?.m1Add">
      <div class="d-flex align-items-center border-radius-0 ">
        <!--<span class="f-s-14">Add Adviser</span>-->
        <span class="f-s-14">Save</span>
      </div>
    </button>
    <!--<button mat-flat-button class="bg-info m-r-10" (click)="AddAdvisor()" *ngIf="updateAdvisorbtn" [disabled]="!UserRoleAccess?.m1Edit">-->
    <button mat-flat-button class="bg-info m-r-10" (click)="AddAdvisor()" *ngIf="updateAdvisorbtn" [disabled]="!UserRoleAccess?.m1Edit">
      <div class="d-flex align-items-center border-radius-0 ">
        <!--<span class="f-s-14">Update Adviser</span>-->
        <span class="f-s-14">Save</span>
      </div>
    </button>

    <button mat-flat-button class="bg-error" (click)=" closeAdvisor()">
      <div class="d-flex align-items-center border-radius-0">
        <span class="f-s-14">Cancel</span>
      </div>
    </button>


  </div>
  <!--</mat-card-content>
  </mat-card>-->
  <div class="spinner-container" *ngIf="ShowSpinner">
    <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
  </div>
</ng-template>

<!--<button (click)="GetProfessionalAdvisorsDetails()">click</button>-->
